import styled from 'styled-components';

export const AddEditWrapper = styled.div`
    @media (min-width: 768px) {
        .form-horizontal .control-label {
            // text-align: left;
        }
    }

    padding-bottom: 20px;

    span.label-warning {
        // color: black;
        font-weight: normal;
    }
`;